@if (icon(); as icon) {
  <ogs-m3-icon [icon]="icon" class="icon"/>
}
@let _name = name();

@if (!collapsed()) {
  @if (hasProjectedContent()) {
    <ng-container>
      <ng-content class="content"/>
    </ng-container>
  } 
		@else if (_name) {
    <span class="name mat-body-medium">{{ _name }}</span>
  }
  @if (additionalIcon(); as additionalIcon) {
    <ogs-m3-icon [icon]="additionalIcon" class="additional-icon"/>
  }
}
